import { PureComponent, ComponentType, Context as ReactContext } from 'react'
import { hoistNonReactStatics } from 'tangle-shared'

function withContext <TContext extends any, TContextName extends string> (Context: ReactContext<TContext>, contextName: TContextName) {
  return function <TProps, TStaticProps> (InnerComponent: ComponentType<TProps & Record<TContextName, TContext>> & TStaticProps) {
    class ContextConsumer extends PureComponent<Pick<TProps, Exclude<keyof TProps, TContextName>>> {

      static displayName = InnerComponent.displayName || InnerComponent.name
      static Component = InnerComponent

      render () {
        const { props } = this
        return (
          <Context.Consumer>
            {
              (context) => {
                const contextProps = { [contextName]: context }
                const Component: any = InnerComponent
                return (
                  <Component { ...props } { ...contextProps } />
                )
              }
            }
          </Context.Consumer>
        )
      }
    }

    const ContextConsumerWithStatics = hoistNonReactStatics(ContextConsumer, InnerComponent)
    return ContextConsumerWithStatics
  }
}

export default withContext
